import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descarga',
    desc: 'Obtienes acceso inmediato a la guía y las plantillas.'
  }, {
    num: '2',
    title: 'Identifica',
    desc: 'Sigues mi checklist para marcar los errores en tu reporte actual.'
  }, {
    num: '3',
    title: 'Envía',
    desc: 'Copias el texto de mis cartas, lo envías por correo certificado y esperas 30 días para ver los resultados.'
  }];
  return <section className="py-24 bg-brand-rose text-white relative clip-diagonal-reverse" data-id="element-54">
      <div className="container mx-auto px-6 relative z-10" data-id="element-55">
        <FadeIn data-id="element-56">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-cream mb-16" data-id="element-57">
            Así de fácil funciona
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto" data-id="element-58">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} direction="up" className="relative" data-id="element-59">
              {/* Connector line for desktop */}
              {index < steps.length - 1 && <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-[2px] bg-brand-gold/30 border-t-2 border-dashed border-brand-gold/50 z-0" data-id="element-60" />}

              <div className="flex flex-col items-center text-center relative z-10" data-id="element-61">
                <div className="w-24 h-24 rounded-full bg-brand-gold text-brand-dark flex items-center justify-center text-4xl font-black mb-6 shadow-lg shadow-brand-gold/20 border-4 border-white/20" data-id="element-62">
                  {step.num}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-brand-cream" data-id="element-63">
                  {step.title}
                </h3>
                <p className="text-white/90 leading-relaxed" data-id="element-64">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}